import React from "react";
import { ErrorMessage, useField } from "formik";
export default function TextField({ ...props }) {
  const [field, meta] = useField(props);
  return (
    <>
      <div class="form-floating mb-3">
        <input
          className={`form-control ${
            meta.touched && meta.error ? "is-invalid" : ""
          }`}
          id={props.name} // Unique ID for accessibility
          {...field}
          {...props}
        />
        <label htmlFor={props.name}>{props.label}</label>
      </div>

      <ErrorMessage
        component="div"
        name={field.name}
        className="error mt-1 ml-2"
      />
    </>
  );
}
